import React, { useState, useEffect } from 'react';
import { Box, Typography, useTheme, useMediaQuery, Button } from '@mui/material';
import { Chip } from '@mui/material';
import { SUBMARKET_SORTING_OPTIONS } from 'src/utils/const';
import { COLOR_PRIMARY_2 } from 'src/utils/colors';

import TooltipNew from 'src/App/Dashboards/Market/Components/Tooltips/TooltipNew';

interface SubmarketFilterProps {
  submarketSortKey: string;
  setSubmarketSortKey: React.Dispatch<React.SetStateAction<string>>;
  fetchSubMarketData: (sortBy: string | undefined, bedroomType: string | undefined) => void;
  isSubmarketAccessAllowed: boolean;
  handleOnSampleClick: (plan: string) => void;
  submarkets: any;
  heatmapMode: string;
}

const SubmarketFilter: React.FC<SubmarketFilterProps> = ({
  submarketSortKey,
  setSubmarketSortKey,
  fetchSubMarketData,
  isSubmarketAccessAllowed,
  handleOnSampleClick,
  submarkets,
  heatmapMode,
}) => {
  const [selectedFilter, setSelectedFilter] = useState<string>(submarketSortKey);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down(900));

  const handleFilterClick = (filterKey: string) => {
    setSelectedFilter(filterKey);
    setSubmarketSortKey(filterKey);
    if (submarkets && submarkets.length === 0) {
      return;
    }
    fetchSubMarketData(filterKey, undefined);
  };

  useEffect(() => {
    if (
      heatmapMode === 'smartZones' &&
      ['yoy_revenue_change', 'neighborhood_grade'].includes(submarketSortKey)
    ) {
      setSelectedFilter('supply');
      setSubmarketSortKey('supply');
    }
  }, [heatmapMode, submarketSortKey]);

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      sx={{
        width: isMobile ? 'auto' : '100%',
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        py: 1,
        px: isMobile ? 1 : 2,
        pl: 0,
        flexWrap: 'nowrap',
        overflowX: 'auto',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          gap: 1,
          flexWrap: 'nowrap',
          //   justifyContent: 'flex-end',
        }}
      >
        {Object.entries(SUBMARKET_SORTING_OPTIONS).map(([key, value]) => {
          return (
            <Chip
              key={key}
              label={
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <value.icon sx={{ fontSize: '18px' }} /> {value.name}
                </Box>
              }
              variant={selectedFilter === key ? 'filled' : 'outlined'}
              onClick={() =>
                isSubmarketAccessAllowed ? handleFilterClick(key) : handleOnSampleClick('expert')
              }
              disabled={
                heatmapMode === 'smartZones' &&
                ['yoy_revenue_change', 'neighborhood_grade'].includes(key)
              }
              sx={{
                borderColor: COLOR_PRIMARY_2,
                color: selectedFilter === key ? '#fff' : COLOR_PRIMARY_2,
                backgroundColor: selectedFilter === key ? COLOR_PRIMARY_2 : 'transparent',
                fontWeight: 500,
                fontSize: '13px',
                height: '32px',
                borderRadius: '20px',
                cursor: 'pointer',
                transition: 'all 0.2s ease-in-out',
                '&:hover': {
                  backgroundColor:
                    selectedFilter === key ? COLOR_PRIMARY_2 : COLOR_PRIMARY_2 + '22',
                  transform: 'translateY(-1px)',
                },
                '&.MuiChip-filled': {
                  backgroundColor: COLOR_PRIMARY_2,
                  color: '#fff',
                },
                '&.MuiChip-outlined': {
                  borderWidth: '1px',
                  borderColor: COLOR_PRIMARY_2,
                  color: COLOR_PRIMARY_2,
                },
              }}
            />
          );
        })}
      </Box>
    </Box>
  );
};

export default SubmarketFilter;
